import { render, staticRenderFns } from "./LastClosedRooms.vue?vue&type=template&id=b7869bfc&scoped=true&"
import script from "./LastClosedRooms.vue?vue&type=script&lang=js&"
export * from "./LastClosedRooms.vue?vue&type=script&lang=js&"
import style0 from "./LastClosedRooms.vue?vue&type=style&index=0&id=b7869bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7869bfc",
  null
  
)

export default component.exports